module.exports = __webpack_public_path__ + "img/green_circle_with_white_cross1.6baefb5.png";